// extracted by mini-css-extract-plugin
export default {"container":"Distance_container__-KkqO","buttons":"Distance_buttons__VIGjK","accordion":"Distance_accordion__ApSDC"};